/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrGridFilter from "@grapecity/wijmo.react.grid.filter"

import React, { useEffect, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import CONSTANT from "../../constant"
import { 区分分類コード } from "../../constant/enum/codes"
import BusyoService from "../../service/master/busyo/busyoService"
import KubunService from "../../service/master/kubun/kubunService"
import SyaryoService from "../../service/truck/syaryoService"
import {
  TSyaryoListGetReq,
  TSyaryoModalList,
} from "../../service/truck/TSyaryo"

import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../type/wijmoComponents"
import ComboBox from "../ComboBox"
import { T部所マスタ } from "../ComboBox/BusyoComboBox"
import { T区分マスタ } from "../ComboBox/KubunComboBox"
import EmptyTextHeader from "../FlexGridWrapper/EmptyTextHeader"
import GridFooter from "../FlexGridWrapper/GridFooter"
import TextInput from "../InputWrapper/TextInput"
import LocalAlertComponent from "../LocalAlertComponent"
import { ModalOuter, TModalTypes } from "../Modal/ModalOuter"
import Spinner from "../Spinner"

/**
 * 車輌検索モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const SyaryoSearchModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    isBusyoComboBoxReadOnly?: boolean
    busyoCode?: string
    原動機有無フラグ?: 1 | 0
    setSyaryo: (value: TSyaryoModalList) => unknown
  }
> = (props) => {
  //#region [state]
  const [initialDataSetFlag, setInitialDataSetFlag] = useState(false)

  // 検索項目
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  const [部所コード, set部所コード] = useState<string | null>()
  const [, set部所] = useState<T部所マスタ | null>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  const [車種コード, set車種コード] = useState<string | null>()
  const [原動機有無フラグ, set原動機有無フラグ] = useState<
    0 | 1 | null | undefined
  >(1)
  const [乗務員名, set乗務員名] = useState<string>()
  const [車番, set車番] = useState<string>()

  // combobox
  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    T部所マスタ["部所コード"],
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)

  // 車種
  const [車種ComboBox, set車種ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["分類コード"],
    T区分マスタ
  > | null>(null)
  const [車種IsLoadEnded, set車種IsLoadEnded] = useState<boolean>(false)

  // 原動機
  const [原動機ComboBox, set原動機ComboBox] = useState<TWijmoComboBox<
    number,
    { value: number; name: string }
  > | null>(null)
  const [原動機IsLoadEnded, set原動機IsLoadEnded] = useState<boolean>(false)
  const [原動機ItemSource] = useState([
    { value: 0, name: "無" },
    { value: 1, name: "有" },
  ])

  // Grid
  const [pageSize, setPageSize] = useState<number>(50)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページサイズ
   * @returns CollectionView
   */

  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjcCore.CollectionView(data, {
      pageSize,
    })

  const [gridData, setGridData] = useState<{
    data: wjcCore.CollectionView
  }>({
    data: createCollectionView([], pageSize),
  })
  const gridInitialized = (grid: wjcGrid.FlexGrid) => {
    grid.itemsSource = gridData.data
    setFlexGrid(grid)
  }

  const search = async (searchCondition?: TSyaryoListGetReq) => {
    setIsSpinnerShow(true)
    setAlertSource(undefined)
    try {
      //TODO: 車輌のAPIに変更必須
      const res = await new SyaryoService().getList({
        廃車フラグ: 0,
        ...searchCondition,
      })
      const newList = createCollectionView(res.data, pageSize)
      flexGrid!.itemsSource = newList
      // 検索結果をstateにセット
      setGridData({ data: newList })
      flexGrid!.refresh()
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsSpinnerShow(false)
    }
  }
  /**
   * 選択ハンドラ
   * @param item
   */
  const submitHandler = (item: TSyaryoModalList) => {
    props.setSyaryo(item)
    props.setIsShow(false)
  }
  //#endregion

  //#region [effect]
  useEffect(() => {
    if (flexGrid == null || 部所ComboBox == null || 原動機ComboBox == null)
      return

    if (props.isShow) {
      // 表示時処理
      Promise.all([
        new BusyoService().getList({}),
        new KubunService().getList(),
      ]).then(([部所ListRes, 区分マスタRes]) => {
        set部所ItemSource(部所ListRes.data)
        set区分ItemSource(区分マスタRes.data)
        props.原動機有無フラグ != null
          ? set原動機有無フラグ(props.原動機有無フラグ)
          : set原動機有無フラグ(1)
        setInitialDataSetFlag(true)
      })
    } else {
      // 非表示時中身を空にして閉じる
      set部所コード("")
      set車種コード("")
      set原動機有無フラグ(1)
      set乗務員名("")
      const newData = {
        data: createCollectionView([], pageSize),
      }
      if (flexGrid != null) {
        flexGrid.itemsSource = newData.data
        flexGrid.refresh()
      }
      setGridData(newData)
    }
  }, [props.isShow, flexGrid, 部所ComboBox, 原動機ComboBox])

  useEffect(() => {
    if (initialDataSetFlag) {
      set原動機有無フラグ(props.原動機有無フラグ)
      props.busyoCode && set部所コード(props.busyoCode)
      setInitialDataSetFlag(false)
    }
  }, [initialDataSetFlag])

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={
        props.title ?? props.原動機有無フラグ === 0
          ? "トレーラ車輌検索"
          : "車輌検索"
      }
      setIsShow={props.setIsShow}
      size={"xl"}
      footer={props.footer}>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid>
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <div className="search-condition-table">
                <div className="search-condition-row">
                  <ComboBox.Busyo
                    placeholder="部所"
                    isAllSelect={true}
                    isReadOnly={props.isBusyoComboBoxReadOnly ?? false}
                    itemsSource={部所ItemSource}
                    isLoadEnded={部所IsLoadEnded}
                    setIsLoadEnded={set部所IsLoadEnded}
                    setSelectedValue={set部所コード}
                    selectedValue={部所コード}
                    setSelectedItem={set部所}
                    ComboBox={部所ComboBox}
                    setComboBox={set部所ComboBox}
                    autoFocus={true}></ComboBox.Busyo>
                  <ComboBox.Kubun
                    placeholder="車種"
                    分類コード={区分分類コード.車輌.車種区分}
                    isLoadEnded={車種IsLoadEnded}
                    setIsLoadEnded={set車種IsLoadEnded}
                    isAllSelect={true}
                    isRequired={true}
                    itemsSource={区分ItemSource}
                    selectedValue={車種コード}
                    setSelectedValue={set車種コード}
                    ComboBox={車種ComboBox}
                    setComboBox={set車種ComboBox}></ComboBox.Kubun>
                  <div className="w-8rem">
                    <ComboBox.Default
                      placeholder="原動機"
                      itemsSource={原動機ItemSource}
                      isLoadEnded={原動機IsLoadEnded}
                      setIsLoadEnded={set原動機IsLoadEnded}
                      selectedValue={原動機有無フラグ}
                      setSelectedValue={(v) => {
                        set原動機有無フラグ(v)
                      }}
                      ComboBox={原動機ComboBox}
                      setComboBox={set原動機ComboBox}></ComboBox.Default>
                  </div>
                  <TextInput
                    style={{ width: "6rem" }}
                    id="車番"
                    name="車番"
                    value={車番}
                    setValue={set車番}
                    maxLength={4}
                    placeholder="車番"
                  />
                  <TextInput
                    id="乗務員名"
                    name="乗務員名"
                    value={乗務員名}
                    setValue={set乗務員名}
                    maxLength={100}
                    placeholder="乗務員名"
                  />
                  <div className="input-group"></div>
                </div>
                <div className="search-condition-row">
                  <Button
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault()
                      search({
                        車番,
                        乗務員名: 乗務員名,
                        車種区分コード: 車種コード ?? "",
                        原動機有無フラグ:
                          原動機有無フラグ != null
                            ? 原動機有無フラグ
                            : undefined,
                        部所コード: 部所コード ?? "",
                      })
                    }}>
                    <FontAwesomeIcon icon={faSearch} />
                    検索
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="text-end mb-2"></Col>
          </Row>
        </form>
        <Row>
          <Col style={{ height: "35rem" }}>
            <wjrGrid.FlexGrid
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
              keyActionTab={wjcGrid.KeyAction.None}
              selectionMode={wjcGrid.SelectionMode.Cell}
              initialized={gridInitialized}
              style={{ height: "30rem" }}>
              <wjrGridFilter.FlexGridFilter />
              <wjrGrid.FlexGridColumn
                width={CONSTANT.GRID.COL_SIZE.COL_CODE_SIZE}
                header="選択"
                align={"center"}
                binding="荷主品名ID">
                <EmptyTextHeader></EmptyTextHeader>
                <wjrGrid.FlexGridCellTemplate
                  cellType={wjrGrid.CellTemplateType.Cell}
                  template={(
                    context: TWijmoCellTemplateContext<TSyaryoModalList>
                  ) => (
                    <Button onClick={() => submitHandler(context.item)}>
                      選択
                    </Button>
                  )}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={80}
                header="車番"
                binding="車番"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={180}
                header="車種"
                binding="車種区分名称1"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={120}
                header="乗務員"
                binding="社員氏名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={180}
                header="部所"
                binding="部所名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={"*"}
                header="備考"
                binding="備考１"></wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
            <GridFooter
              pageSize={pageSize}
              setPageSize={setPageSize}
              gridData={gridData}
              isEnableExport={false}
              flexGrid={flexGrid}></GridFooter>
          </Col>
        </Row>
      </Container>
    </ModalOuter>
  )
}

export default SyaryoSearchModal
